import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import * as Actions from "../window-minimize/actions/actions";

export default class MobileMutator {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getMutator() {
        return (parameters = {}) => {
            if (this._store?.getState()?.Conversation?.Channel == this._settings.channelConstants.channels.MobileApp) 
            {
                let windowClass = this._settings.classNames.windowClassName;

                if(this._store.getState()?.DeviceType === this._settings.mobileConstants.deviceTypes.tablet){
                    windowClass = this._settings.classNames.tabletClassName;
                }

                const windowElement = document.getElementsByClassName(windowClass)[0] as HTMLElement;

                if (windowElement != null && windowElement != undefined){ 
                    windowElement.style.setProperty('height', '100%', 'important');
                    windowElement.style.setProperty('width', '100%', 'important');
                    windowElement.style.setProperty('left', '0px', 'important');
                    windowElement.style.setProperty('top', '0px', 'important');
                }

                const minimizeClass = this._settings.classNames.minimizeClassName;
                const minimizeElement = document.getElementsByClassName(minimizeClass)[0] as HTMLElement;

                if (minimizeElement != null && minimizeElement != undefined) {
                    minimizeElement.style.display = "none";                    
                }

                if(this._store?.getState()?.Window.IsMinimized){
                    const { IsMinimized } = this._settings.stateLocations.Window;                    
                    this._store.dispatch(Actions.setMinimize(false, IsMinimized));
                }
            }
            
            return parameters;
        };
    }
}


// WEBPACK FOOTER //
// ./modules/mutators/mobileMutator.ts